export type AssignmentStatus =
  | 'NEW'
  | 'ASSIGNED'
  | 'COMPLETED'
  | 'SUBMITTED'
  | 'CANCELED'
  | 'CANCELED_REASSIGNED'
  | 'FOLLOW_UP'
  | 'OPEN'
  | 'CLOSED';

export const isOpenStatus = (status: AssignmentStatus) =>
  ['NEW', 'ASSIGNED', 'COMPLETED', 'FOLLOW_UP'].includes(status);

export const isInReviewStatus = (status: AssignmentStatus) =>
  ['FOLLOW_UP', 'COMPLETED'].includes(status);

export const isCompletedStatus = (status: AssignmentStatus) =>
  ['COMPLETED', 'FOLLOW_UP', 'SUBMITTED'].includes(status);

export const isClosedStatus = (status: AssignmentStatus) =>
  !isOpenStatus(status);

export type BillingStatus = 'NOT_PAID' | 'PAID' | 'NOT_BILLABLE';
